import {StyledProjectSection,StyledProjectSectionContainer}  from "./Projects.styled";
import  {ProjectComponent,StatusIndicator}  from "./ProjectComponent";
import {data} from "../../Data/ProjectsData"
import {TagContainer} from "../Tag/TagContainer"
import { TagComponent } from "../Tag/TagComponent";


export const Projects = () => {
  return (
    <StyledProjectSectionContainer bColor={"rgb(0,0,0,0.03)"} id = "projects">
      <h1>Projects</h1>
      <StyledProjectSection>
        {data.slice(0, 3).map((item) => {
          return (
            <ProjectComponent key={item.id}>

              <div>
                <img src={item.image} alt="" />
              </div>

              <div>
                <h2>{item.title}</h2>
                <p>{item.summary}</p>
                <TagContainer>
                  {item.technologies.map((skill) => {
                    return (
                      <>
                        <TagComponent key={Math.random() * 10000}>
                          <>
                            {skill}
                            <br></br>
                          </>
                        </TagComponent>
                      </>
                    );
                  })}
                </TagContainer>
                <StatusIndicator>{item?.status}</StatusIndicator>
                <a href={item.link} target="no_blank">
                  Visit Live Demo &rarr;
                </a>
              </div>
            </ProjectComponent>
          );
        })}
      </StyledProjectSection>
    </StyledProjectSectionContainer>
  );
 }
